
import Grid from '@mui/material/Grid'; // Importa el componente Grid de Material UI, usado para crear diseños en cuadrícula
import CustomCard from './CustomCard'; // Importa el componente CustomCard, que muestra una tarjeta personalizada

export default function Cards() { // Define el componente funcional Cards
  return (
    <Grid container columns={8} spacing={2} maxWidth="80%" paddingLeft="20%" paddingTop="5%"> {/* Crea un contenedor Grid con 10 columnas, espacio entre elementos y un máximo de ancho del 80% de la pantalla */}
      <Grid item xs={12} sm={6} md={2}> {/* Otra celda para una tarjeta más */}
        <CustomCard path="Koch.png" title="Copo de Koch" redirect="koch" /> {/* Tarjeta con la imagen, título y redirección de Koch snowflake */}
      </Grid>
        <Grid item xs={12} sm={6} md={2}> {/* Celda con tarjeta */}
        <CustomCard path="Hilbert.png" title="Curva de Hilbert" redirect="hilbert" /> {/* Tarjeta con la imagen y título de Hilbert's curve */}
      </Grid>
      <Grid item xs={12} sm={6} md={2}> {/* Otra celda de tarjeta */}
        <CustomCard path="LSystems.png" title="Sistemas L" redirect="l-systems" /> {/* Tarjeta para L-systems con la ruta correspondiente */}
      </Grid>
      <Grid item xs={12} sm={6} md={2}> {/* Una más para una tarjeta */}
        <CustomCard path="BinauralKoch.png" title="Koch Binaural" redirect="binaural-koch" /> {/* Tarjeta con la imagen y título de Binaural Koch */}
      </Grid>
      <Grid item xs={12} sm={6} md={2}> {/* Una celda para una tarjeta adicional */}
        <CustomCard path="Tiling.png" title="Teselaciones" redirect="tiling" /> {/* Tarjeta con la imagen, título y redirección de Tiling sonification */}
      </Grid>    
      <Grid item xs={12} sm={6} md={2}> {/* Celda de tarjeta */}
        <CustomCard path="Rose.png" title="Rose is a rose is a rose" redirect="rose" /> {/* Tarjeta con la imagen y título de Rose in a rose in a rose */}
      </Grid>
      <Grid item xs={12} sm={6} md={2}> {/* Última celda de tarjeta */}
        <CustomCard path="Soundscape.png" title="Paisaje sonoro fractal" redirect="soundscape" /> {/* Tarjeta con la imagen y título de Fractal soundscape */}
      </Grid>
      <Grid item xs={12} sm={6} md={2}> {/* Otra celda para una tarjeta */}
        <CustomCard path="BioChemical.png" title="Sonificación de datos bioquímicos" redirect="bio-chemical" /> {/* Tarjeta con la imagen y título de BioChemical */}
      </Grid>
    </Grid>
  );
}


